<template>
	<div class="projectDetail-container">
		<div v-loading="projectDetailLoading" class="project-detail-content">
			<!-- 详情-表格数据 -->
			<div class="common-detail-table">
				<table>
					<tr>
						<th>项目名称</th>
						<td>{{ projectDetailObject.projectName ? projectDetailObject.projectName : '/' }}</td>
						<th>项目地址</th>
						<td>{{ projectDetailObject.address ? projectDetailObject.address : '/' }}</td>
						<th>统一地址描述</th>
						<td>{{ projectDetailObject.addressDescription ? projectDetailObject.addressDescription : '/' }}</td>
					</tr>
					<tr>
						<th>统一地址识别码</th>
						<td>
							{{ projectDetailObject.addressIdentificationCode ? projectDetailObject.addressIdentificationCode : '/' }}
						</td>
						<th>项目分类</th>
						<td>{{ projectDetailObject.projectTypeName ? projectDetailObject.projectTypeName : '/' }}</td>
						<th>工程用途</th>
						<td>{{ projectDetailObject.projectPurposeName ? projectDetailObject.projectPurposeName : '/' }}</td>
					</tr>
					<tr>
						<th>项目编码</th>
						<td>{{ projectDetailObject.projectCode ? projectDetailObject.projectCode : '/' }}</td>
						<th>建设性质</th>
						<td>{{ projectDetailObject.projectPropertyName ? projectDetailObject.projectPropertyName : '/' }}</td>
						<th>所属地市州</th>
						<td>{{ projectDetailObject.cityName ? projectDetailObject.cityName : '/' }}</td>
					</tr>
					<tr>
						<th>所属区县</th>
						<td>{{ projectDetailObject.countyName ? projectDetailObject.countyName : '/' }}</td>
						<th>建设单位名称</th>
						<td>{{ projectDetailObject.constructionUnit ? projectDetailObject.constructionUnit : '/' }}</td>
						<th>唯一代码</th>
						<td>{{ projectDetailObject.constructionUnitCode ? projectDetailObject.constructionUnitCode : '/' }}</td>
					</tr>
					<tr>
						<th>总投资（万元）</th>
						<td>{{ projectDetailObject.money ? projectDetailObject.money : '/' }}</td>
						<th>总面积（平方米）</th>
						<td>{{ projectDetailObject.area ? projectDetailObject.area : '/' }}</td>
						<th>报建日期</th>
						<td>{{ projectDetailObject.constructionTime ? projectDetailObject.constructionTime : '/' }}</td>
					</tr>
					<tr>
						<th>建设规模</th>
						<td>{{ projectDetailObject.constructionScale ? projectDetailObject.constructionScale : '/' }}</td>
						<th>立项文号</th>
						<td>{{ projectDetailObject.documentCode ? projectDetailObject.documentCode : '/' }}</td>
						<th>立项级别</th>
						<td>{{ projectDetailObject.projectLevelName ? projectDetailObject.projectLevelName : '/' }}</td>
					</tr>
					<tr>
						<th>GIS经度</th>
						<td>{{ projectDetailObject.gisLon ? projectDetailObject.gisLon : '/' }}</td>
						<th>GIS维度</th>
						<td>{{ projectDetailObject.gisLat ? projectDetailObject.gisLat : '/' }}</td>
						<th></th>
						<td></td>
					</tr>
				</table>
			</div>
		</div>
		<!-- 未开通会员提示 -->
		<nonbind-vip v-if="isVip"></nonbind-vip>
		<!-- 未开通超级会员提示 -->
		<nonbind-svip v-if="isSVip"></nonbind-svip>
	</div>
</template>

<script>
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import NonbindSvip from '@/components/NonBind/nonbindSVip.vue'
	import { getProjectDetail } from '@/api/qualificationQuery/project'
	import { transObject } from '@/utils/index'
	// 项目详细信息
	export default {
		name: 'ProjectDetail',
		components: { NonbindVip, NonbindSvip },
		props: {
			id: {
				type: String,
				required: true,
				default: ''
			}
		},
		data() {
			return {
				// 数据加载状态
				projectDetailLoading: false,
				isVip: false,
				isSVip: false,
				// 项目详情对象
				projectDetailObject: {
					id: '',
					// 项目名称
					projectName: '',
					// 项目地址
					address: '',
					// 统一地址描述
					addressDescription: '',
					// 统一地址识别码
					addressIdentificationCode: '',
					// 项目分类
					projectType: '',
					projectTypeName: '',
					// 工程用途
					projectPurpose: '',
					projectPurposeName: '',
					// 项目编码
					projectCode: '',
					// 建设性质
					projectProperty: '',
					projectPropertyName: '',
					// 所属地市州
					cityCode: '',
					cityName: '',
					// 所属区县
					countyCode: '',
					countyName: '',
					// 建设单位名称
					constructionUnit: '',
					// 唯一代码
					constructionUnitCode: '',
					// 总投资
					money: '',
					// 总面积
					area: '',
					// 报建日期
					constructionTime: '',
					// 建设规模
					constructionScale: '',
					// 数据等级
					dataLevel: '',
					// 立项文号
					documentCode: '',
					// 立项级别
					projectLevel: '',
					projectLevelName: '',
					// GIS经度
					gisLon: '',
					// GIS纬度
					gisLat: '',
					isCollect: false,
					isMonitoring: false
				}
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.initDetail()
		},
		methods: {
			initDetail() {
				this.projectDetailLoading = true
				const params = {
					projectId: this.id
				}

				getProjectDetail(params)
					.then(response => {
						const { data, code, message } = response
						if (code === 6102) {
							this.isVip = true
						} else if (code === 6104) {
							// 当前是svip 权益已经使用完，提示次数已经用完了，请等待会员权益重置再使用
							this.$message.warning(message)
						} else if (code === 6105) {
							// 当前是vip 权益已经使用完，提示次数已经用完了，请用户升级为svip
							this.isSVip = true
						} else {
							if (data) {
								// 将目标数据转为我指定的属性对象
								transObject(data, this.projectDetailObject)
							}
						}
						this.projectDetailLoading = false
					})
					.catch(error => {
						this.projectDetailLoading = false
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/table.scss';
	@import '../../styles/project.scss';
</style>
